import { render } from "./TheWholesale.vue?vue&type=template&id=f0e7e65e&scoped=true"
import script from "./TheWholesale.vue?vue&type=script&lang=js"
export * from "./TheWholesale.vue?vue&type=script&lang=js"

import "./TheWholesale.vue?vue&type=style&index=0&id=f0e7e65e&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e7e65e"]])

export default __exports__